/**
 * The last figures this browser saw, kept so the page can show them the
 * moment it opens and replace them when the new ones arrive (2026-10-05).
 * Per browser, for convenience only: any failure just means waiting, as
 * before. The version in the name keeps an older shape from ever being read.
 */
export const KEPT = 'ww-usage-v1'

export function readKept<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key)
    return raw ? (JSON.parse(raw) as T) : null
  } catch {
    return null
  }
}

export function keep(key: string, value: unknown) {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch {
    /* full or refused: the next visit simply waits */
  }
}
